import React from "react"

function Overlay(props) {
    
    function handleClick() {
        const show = "off"
        props.callBack(show)
    }
    
    return (
        <div id="overlay" onClick={handleClick}>
            <div className="overlayTextWrapper">
                <h1 id="overlayText">{props.overlayText}</h1>
                <p>click to continue</p>
            </div>
        </div>
    )
}

export default Overlay